const checklisttemplate = {
	module: "General Checklist",
	list_title: "Checklist Templates",
	new_title: "New Checklist Template",
	edit_title: "Edit Checklist Template",
	id: "ID",
	title: "Title",
	description: "Description",
	checklist_type: "Checklist Type",
	formula_type: "Formula Type",
	not_affect_status: "Not Affect Status",
	checklist_template_api_id: "Checklist Template API",
	machine_group: "Machine Group",
	status: "Status",
	text_field: "Text field",
	text_area: "Text area",
	radio: "Radio",
	select: "Select",
	signature: "Signature",
	label: "Label",
	checkbox: "Checkbox",
	date: "Date",
	time: "Time",
	divider: "Divider",
	component: "Component",
	checkpoint_123s: "Checkpoint 123S",
	checkpoint_radio_status: "Checkpoint Radio Status",
	checkpoint_f1_123s: "Radio 0-3, NA",
	checkpoint_f2_123s: "Radio A-D, NA",
	checkpoint_f3_123s: "Radio K R",
	checkpoint_f4_123s: "Formula4 Checkpoint 123S",
	panel: "Panel",
	comments: "Comments",
	switch: "Switch",
	file: "File",
	grid: "Grid",
	value: "Value",
	templateHeader: "PDF Header",
	updated_on: "Updated on",
};
export default checklisttemplate;